var _RowComponentTypeMap,
  _jsxFileName = "/Users/vincent.limshowchen/Sites/account-components/src/components/ListContainer/index.js";
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from "react";
import FollowRow from "../FollowRow";
import TeamFilterRow from "../TeamFilterRow";
import { ListContainerContainer } from "./styles";
export var ListContainerTypes = {
  FILTER: "FILTER",
  FOLLOW: "FOLLOW"
};
var RowComponentTypeMap = (_RowComponentTypeMap = {}, _defineProperty(_RowComponentTypeMap, ListContainerTypes.FILTER, TeamFilterRow), _defineProperty(_RowComponentTypeMap, ListContainerTypes.FOLLOW, FollowRow), _RowComponentTypeMap);
var ComponentKey = "list-container";
var ListContainer = function ListContainer(_ref) {
  var className = _ref.className,
    containerProps = _ref.containerProps,
    favoriteId = _ref.favoriteId,
    items = _ref.items,
    onClick = _ref.onClick,
    rowProps = _ref.rowProps,
    type = _ref.type;
  if (!type) {
    // eslint-disable-next-line
    console.error("❌ [ListContainer] prop `type` is required");
    return null;
  }
  var RowComponent = RowComponentTypeMap[type];
  return /*#__PURE__*/React.createElement(ListContainerContainer, _extends({
    className: className,
    "data-testid": ComponentKey
  }, containerProps, {
    __source: {
      fileName: _jsxFileName,
      lineNumber: 35,
      columnNumber: 5
    }
  }), items === null || items === void 0 ? void 0 : items.map(function (item) {
    var _item$id;
    /**
     * 1. Create inline click handler in order to pass along the item data
     * 2. Determine which prop to use based on ListContainerTypes
     *   - TeamFilterRow expects `handlers`, FollowRow expects `followHandlers`
     */
    var onItemClick = function onItemClick(e) {
      return onClick(e, item);
    };
    var handlersKey = type === ListContainerTypes.FILTER ? "handlers" : "followHandlers";
    var handlersProp = _defineProperty({}, handlersKey, {
      onClick: onItemClick
    });
    return /*#__PURE__*/React.createElement(RowComponent, _extends({
      key: item.id
    }, item, {
      isFavorite: (favoriteId === null || favoriteId === void 0 ? void 0 : favoriteId.toString()) === ((_item$id = item.id) === null || _item$id === void 0 ? void 0 : _item$id.toString())
    }, handlersProp, rowProps, {
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55,
        columnNumber: 11
      }
    }));
  }));
};
export default /*#__PURE__*/React.memo(ListContainer);